import type { MouseEventHandler, ReactNode } from 'react';

import type {
  ButtonIcon,
  ButtonVariant,
} from '#/components/Button/Button.types';
import { useFormContext } from '#/components/Form/FormContext';

import { SubmitBaseButton } from './SubmitBaseButton';

type Props = {
  qaId?: string;
  disabled?: boolean;
  isSubmitting?: boolean;
  submitting?: boolean;
  children?: ReactNode;
  onClick?: MouseEventHandler;
  fullWidth?: boolean;
  width?: number;
  size?: 'small' | 'medium' | 'large';
  type?: 'submit' | 'button';
  tabIndex?: number;
  variant?: ButtonVariant;
  icon?: ButtonIcon;
};

export function SubmitButton({ qaId, isSubmitting, ...props }: Props) {
  const { fieldQaIdPrefix, submitting, submitDisabled } = useFormContext();

  return (
    <SubmitBaseButton
      variant="primary"
      qaId={
        qaId ??
        (fieldQaIdPrefix ? `${fieldQaIdPrefix}-submit-button` : 'submit-button')
      }
      submitting={submitting || isSubmitting}
      submitDisabled={submitDisabled}
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
